import { Flame } from "lucide-react";

const ITEMS = [
  "Pâte levée 72h",
  "Maturation lente",
  "Farine italienne",
  "Cuisson 450°C",
  "Commander & emporter",
];

export default function Marquee() {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {ITEMS.map((t) => (
        <span key={`${key}-${t}`} className="flex items-center">
          <span className="font-editorial px-8 text-2xl italic text-dim/70 sm:text-3xl">{t}</span>
          <Flame size={15} className="text-terra/50" />
        </span>
      ))}
    </div>
  );

  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-border/60 bg-surface-1 py-6">
      <div className="marquee-track">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
}
